export default {
  data() {
    return {
      usersDropdownData: {
        mobileDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortUsers(this.teamsSettings[this.$route.params.team].listsSettings.users.order.col, "ASC");
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortUsers(this.teamsSettings[this.$route.params.team].listsSettings.users.order.col, "DESC");
                },
                icon: "Icon=check.svg",
              },
            ],
          },
          {
            title: this.$t("dropdowns.sortingBy"),
            options: [
              {
                label: this.$t("user.name"),
                key: "last_name",
                method: () => {
                  this.sortUsers(
                    "last_name",
                    this.teamsSettings[this.$route.params.team].listsSettings.users.order.dir
                  );
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.email"),
                key: "locale",
                method: () => {
                  this.sortUsers("email", this.teamsSettings[this.$route.params.team].listsSettings.users.order.dir);
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.title"),
                key: "gender",
                method: () => {
                  this.sortUsers("gender", this.teamsSettings[this.$route.params.team].listsSettings.users.order.dir);
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.created_at"),
                key: "created_at",
                method: () => {
                  this.sortUsers(
                    "created_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.users.order.dir
                  );
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.invited_at"),
                key: "invited_at",
                method: () => {
                  this.sortUsers(
                    "invited_at",
                    this.teamsSettings[this.$route.params.team].listsSettings.users.order.dir
                  );
                },
                icon: "Icon=check.svg",
              },
            ],
          },
        ],
        sortMainColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            key: "last_name",
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortUsers("last_name", "ASC");
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortUsers("last_name", "DESC");
                },
                icon: "Icon=check.svg",
              },
            ],
          },
        ],
        showAsFirstColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortUsers(
                    this.teamsSettings[this.$route.params.team].listsSettings.users.showAs.firstCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortUsers(
                    this.teamsSettings[this.$route.params.team].listsSettings.users.showAs.firstCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("user.email"),
                key: "email",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      firstCol: {
                        label: "user.email",
                        key: "email",
                        format: "none",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.status"),
                key: "status",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      firstCol: {
                        label: "user.status",
                        key: "status",
                        format: "userStatus",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.title"),
                key: "gender",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      firstCol: {
                        label: "user.title",
                        key: "gender",
                        format: "title",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.role"),
                key: "role",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      firstCol: {
                        label: "user.role",
                        key: "role",
                        format: "role",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      firstCol: {
                        label: "user.created_at",
                        key: "created_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.invited_at"),
                key: "invited_at",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      firstCol: {
                        label: "user.invited_at",
                        key: "invited_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
            ],
          },
        ],
        showAsSecondColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortUsers(
                    this.teamsSettings[this.$route.params.team].listsSettings.users.showAs.secondCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortUsers(
                    this.teamsSettings[this.$route.params.team].listsSettings.users.showAs.secondCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("user.email"),
                key: "email",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      secondCol: {
                        label: "user.email",
                        key: "email",
                        format: "none",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.status"),
                key: "status",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      secondCol: {
                        label: "user.status",
                        key: "status",
                        format: "userStatus",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.title"),
                key: "gender",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      secondCol: {
                        label: "user.title",
                        key: "gender",
                        format: "title",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.role"),
                key: "role",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      secondCol: {
                        label: "user.role",
                        key: "role",
                        format: "role",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      secondCol: {
                        label: "user.created_at",
                        key: "created_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.invited_at"),
                key: "invited_at",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      secondCol: {
                        label: "user.invited_at",
                        key: "invited_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
            ],
          },
        ],
        showAsThirdColDropdown: [
          {
            title: this.$t("dropdowns.sortingDirection"),
            disabled: false,
            options: [
              {
                label: this.$t("dropdowns.asc"),
                key: "ASC",
                method: () => {
                  this.sortUsers(
                    this.teamsSettings[this.$route.params.team].listsSettings.users.showAs.thirdCol.key,
                    "ASC"
                  );
                },
                icon: "Icon=check.svg",
                disabled: false,
              },
              {
                label: this.$t("dropdowns.desc"),
                key: "DESC",
                method: () => {
                  this.sortUsers(
                    this.teamsSettings[this.$route.params.team].listsSettings.users.showAs.thirdCol.key,
                    "DESC"
                  );
                },
                icon: "Icon=check.svg",
                disabled: false,
              },
            ],
          },
          {
            title: this.$t("dropdowns.showAs"),
            options: [
              {
                label: this.$t("user.email"),
                key: "email",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      thirdCol: {
                        label: "user.email",
                        key: "email",
                        format: "none",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.status"),
                key: "status",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      thirdCol: {
                        label: "user.status",
                        key: "status",
                        format: "userStatus",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.title"),
                key: "gender",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      thirdCol: {
                        label: "user.title",
                        key: "gender",
                        format: "title",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.role"),
                key: "role",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      thirdCol: {
                        label: "user.role",
                        key: "role",
                        format: "role",
                        size: 1,
                        sortable: false,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.created_at"),
                key: "created_at",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      thirdCol: {
                        label: "user.created_at",
                        key: "created_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
              {
                label: this.$t("user.invited_at"),
                key: "invited_at",
                method: () => {
                  this.changeCol({
                    list: "users",
                    showAs: {
                      thirdCol: {
                        label: "user.invited_at",
                        key: "invited_at",
                        format: "dateFromNow",
                        size: 1,
                        sortable: true,
                      },
                    },
                  });
                },
                icon: "Icon=check.svg",
              },
            ],
          },
        ],
        filterDropdown: [
          {
            title: this.$t("filters.filterUsers"),
            options: [
              {
                label: this.$t("filters.isInvited"),
                column: 1,
                switch: {
                  name: "is_invited",
                  model: true,
                },
                checkbox: true,
                method: () => {},
                hoverBg: true,
              },
              {
                label: this.$t("filters.isActive"),
                column: 1,
                switch: {
                  name: "is_active",
                  model: true,
                },
                method: () => {},
                checkbox: true,
                hoverBg: true,
              },
              {
                label: this.$t("filters.activateFilter"),
                border: "border-top",
                color: "primary",
                position: "center",
                method: () => {
                  this.setUsersFilters();
                },
                noActiveState: true,
                button: true,
                multiColumnsBottomNav: true,
              },
              {
                label: this.$t("filters.resetFilter"),
                color: "text-danger",
                position: "center",
                method: () => {
                  this.resetFilters(this.setUsersFilters);
                },
                hoverBg: true,
                noActiveState: true,
                multiColumnsBottomNav: true,
              },
            ],
          },
        ],
      },
    };
  },
};
